var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeoples(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 12.5C14.2912 12.5 16.25 10.5412 16.25 8.125C16.25 5.70876 14.2912 3.75 11.875 3.75C9.45875 3.75 7.5 5.70876 7.5 8.125C7.5 10.5412 9.45875 12.5 11.875 12.5Z",
    stroke: "#082026",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3799 4.375C21.6504 5.14056 22.5001 6.53356 22.5001 8.125C22.5001 9.71644 21.6504 11.1094 20.3799 11.875",
    stroke: "#082026",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 25.5V26.25H21.25V25.5C21.25 22.6997 21.25 21.2996 20.7051 20.2301C20.2257 19.2892 19.4608 18.5243 18.5199 18.0449C17.4504 17.5 16.0503 17.5 13.25 17.5H10.5C7.69975 17.5 6.29963 17.5 5.23005 18.0449C4.28924 18.5243 3.52433 19.2892 3.04497 20.2301C2.5 21.2996 2.5 22.6997 2.5 25.5Z",
    stroke: "#082026",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5001 26.25V25.5C27.5001 22.6997 27.5001 21.2996 26.9551 20.23C26.4758 19.2892 25.7108 18.5243 24.77 18.0449",
    stroke: "#082026",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoples);
export default __webpack_public_path__ + "static/media/peoples.bd1484b092b14373c63fc0cb38a2a251.svg";
export { ForwardRef as ReactComponent };